// src/pages/ChatPage.jsx
import React, { useCallback } from 'react';
import ChatBox from '../components/ChatBox';
import { ArrowRight, MessageCircle } from '../components/icons';
import { useChatViewport } from '../components/ChatUI';
import { useNavigate } from 'react-router-dom';

export default function ChatPage() {
  const navigate = useNavigate();
  const viewport = useChatViewport();
  const close = useCallback(() => navigate(-1), [navigate]);

  return (
    <div className="chat-viewport" dir="rtl" style={viewport}>
      <div className="chat-shell">
      {/* هدر */}
      <header className="chat-header">
        <button
          onClick={close}
          className="chat-icon-button"
          aria-label="بازگشت"
        >
          <ArrowRight className="w-6 h-6" />
        </button>
        <div className="chat-header-avatar"><MessageCircle size={22} /></div>
        <div><h1>پشتیبانی آنلاین</h1><p>گفتگو با پشتیبانی ESF Gold</p></div>
      </header>

      {/* چت‌باکس — تمام فضای باقی‌مانده */}
      <div className="chat-body">
        <ChatBox onClose={close} />
      </div>
      </div>
    </div>
  );
}
